const constants = {
    AUTH_URL: '/mailboxAuth',
    GMAIL_ACCOUNT_TYPE: 'gmail-account',
    GOOGLE_GROUP_ACCOUNT_TYPE: 'google-group-account',
    USER_TYPE: 'User type',
    GROUP_TYPE: 'Google group',
    VERIFICATION_STATUS: {
        MISMATCH: "mismatch",
        SUCCESS: "success"
    }
};

export { constants };